import request from '@/utils/request'
import { hasPermission } from '@/utils/auth'
export async function fetchCandidateRows(query = '') {
  if (!hasPermission('vehicle:list')) return []
  const response = await request.get('/webserver/waybill/vehicles', { params: { vehicleNo: query, status: 1, page: 1, limit: 50 } })
  return (response.data.items || []).filter(row => Number(row.status) === 1).map(row => ({ ...row, id: `v-${row.vehicleNo}_${row.plateColor}`, type: 'VEHICLE', isLeaf: true, vehiclePlateColor: String(row.plateColor), label: row.vehicleNo }))
}

export async function queryNativePosition(identity, conditions = {}) {
  if (!hasPermission('truck:position')) throw new Error('没有货车定位权限')
  const form = new FormData()
  form.append('vnos', `${identity.vehicleNo}_${identity.plateColor}`)
  for (const key of ['startLonlat', 'endLonlat', 'startAreaCode', 'endAreaCode', 'timeNearby']) {
    if (conditions[key] != null && conditions[key] !== '') form.append(key, conditions[key])
  }
  const response = await request.post('/webserver/getTruckLastLocation', form, { contentType: 1 })
  const { normalizePositionRows } = require('./nativeVehicleMonitoring')
  const rows = normalizePositionRows(response.data || {}, [identity])
  return rows.length ? { ...rows[0], resultStatus: 'SUCCESS' } : { resultStatus: 'NO_DATA', message: '暂无可确认身份的有效位置' }
}

export async function queryNativeHistory(identity, conditions) {
  if (!hasPermission('truck:track')) throw new Error('没有货车轨迹权限')
  const { validateTrackTimeRange } = require('./vehicleMonitoringSession')
  const parse = value => Date.parse(String(value).replace(' ', 'T') + '+08:00')
  validateTrackTimeRange(parse(conditions.qryBtm), parse(conditions.qryEtm))
  const form = new FormData()
  form.append('vclN', identity.vehicleNo)
  form.append('vco', identity.plateColor)
  for (const key of ['qryBtm', 'qryEtm', 'startLonlat', 'endLonlat', 'startAreaCode', 'endAreaCode', 'parkMins']) {
    if (conditions[key] != null && conditions[key] !== '') form.append(key, conditions[key])
  }
  const response = await request.post('/webserver/queryTruckHisTrack', form, { contentType: 1 })
  const { normalizeHistoryResult } = require('./nativeVehicleMonitoring')
  return normalizeHistoryResult(response.data || {}, identity)
}
